module.exports = __webpack_public_path__ + "static/labs-group-sp22-416ac117cc2b2327714096edf1937ea1.jpg";